import React, { useEffect, useRef, useState } from "react";
import HighChartsMap from "../../components/highCharts/HighChartsMap";
import Highcharts from "highcharts/highmaps";
import IranMap from "@highcharts/map-collection/countries/ir/ir-all.geo.json"; // نقشه ایران
import styles from "./map.module.scss";
import {
	Dialog,
	DialogContent,
	DialogTitle,
	Card,
	CardContent,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/img/logo.svg";
import { useGetDataQuery } from "../../services/api/general.service";

function MapView() {
	const navigate = useNavigate();
	const [modal, setModal] = useState({ visibility: false, data: [] });
	const { data, isLoading } = useGetDataQuery();
	const chartRef = useRef();

	const [options, setOptions] = useState({
		chart: {
			map: IranMap,
		},
		title: {
			text: "لیست داروخانه‌های ایران",
			align: "center",
		},
		mapNavigation: {
			enabled: true,
			buttonOptions: {
				verticalAlign: "bottom",
			},
		},
		plotOptions: {
			series: {
				events: {
					click: (event) => {
						setModal({ visibility: true, data: event.point.data });
					},
				},
				nullColor: "#000",
			},
		},
		series: [],
	});

	// تبدیل داده‌های بکند به فرمت HighCharts
	const convertDataForMap = (backendData) => {
		const model = [];
		backendData.map((province) => {
			model.push([
				province.code,
				{
					name: province.provinceTitle,
					data: province.customers.map((customer) => {
						return {
							name: customer.customerTitle,
							address: customer.customerAddress,
							phone: customer.customerPhone || "بدون شماره",
						};
					}),
				},
			]);
		});

		return model;
	};

	useEffect(() => {
		if (data && data.length) {
			const convertedData = convertDataForMap(data);

			setOptions((prevOptions) => ({
				...prevOptions,
				series: [
					{
						name: "لیست داروخانه‌های فروش تیالیا",
						data: convertedData,
						joinBy: null, // اتصال داده‌ها به کد نقشه
						borderColor: "#FFF",
						keys: ["name", "data", "woe-name", "woe-label", "color"],
						states: {
							hover: {
								color: "#BADA55",
							},
						},
						tooltip: {
							headerFormat: "",
							pointFormatter() {
								return `<b>${this.data.name}</b>`;
							},
						},
						dataLabels: {
							enabled: true,
							format: "{point.data.name}",
						},
					},
					{
						name: "Connectors",
						type: "mapline",
						color: "rgba(130, 130, 130, 0.5)",
						zIndex: 5,
						showInLegend: true,
						enableMouseTracking: false,
						accessibility: {
							enabled: true,
						},
					},
				],
				plotOptions: {
					series: {
						events: {
							click: (item) => {
								setModal({ visibility: true, data: item.point.data.data });
							},
						},
						nullColor: "#000",
					},
					nullColor: "#000",
				},
			}));
		}
	}, [data]);
	useEffect(() => {
		// console.log("cccccc", options);
	}, [options]);

	return (
		<div className={styles.container}>
			<div className="flex justify-between my-6">
				<img src={logo} className="w-32" alt="" />

				<button
					onClick={() => {
						navigate("/");
					}}
					className="bg-sky-600 p-2 rounded-lg text-white"
				>
					بازگشت
				</button>
			</div>
			<div>
				{isLoading && data?.length === 0 ? (
					<p>در حال بارگذاری...</p>
				) : (
					<HighChartsMap
						highcharts={Highcharts}
						options={options}
						constructorType={"mapChart"}
						ref={chartRef}
					/>
				)}
				<Dialog
					closeAfterTransition
					open={modal.visibility}
					onClose={() => setModal({ visibility: false, data: [] })}
					maxWidth="md"
					fullWidth={true}
				>
					<DialogTitle
						className={styles.titleContainer}
						sx={{ background: "#d8d8d8" }}
					>
						<h3>جزئیات استان</h3>
						<p
							onClick={() => {
								setModal({ visibility: false, data: [] });
							}}
							style={{ cursor: "pointer" }}
						>
							X
						</p>
					</DialogTitle>
					<DialogContent sx={{ background: "#d8d8d8" }}>
						{modal.data?.map((pharma, index) => (
							<Card key={index} sx={{ padding: "8px", marginBottom: "10px" }}>
								<h4>{pharma.name}</h4>
								<CardContent>{pharma.address}</CardContent>
								{pharma.phone && (
									<a href={`tel:${pharma.phone}`}>{pharma.phone}</a>
								)}
							</Card>
						))}
					</DialogContent>
				</Dialog>
			</div>
		</div>
	);
}

export default MapView;
